import { useEffect, useState } from "react";

export default function AventuraHeroSection() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <section
      id="hero"
      className="relative min-h-[520px] md:min-h-[600px] flex items-center overflow-hidden"
    >
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Beautiful%20aerial%20view%20of%20Aventura%20Florida%20downtown%20district%20with%20luxury%20waterfront%20condo%20towers%20reflections%20on%20calm%20water%20at%20golden%20hour%20evening%20sunset%20tropical%20palm%20trees%20scenic%20skyline%20professional%20drone%20photography%20vibrant%20colors%20no%20text%20no%20logo&width=1600&height=900&seq=aventura-hero-v2&orientation=landscape"
          alt="Aventura, Florida waterfront skyline"
          className="w-full h-full object-cover object-center"
          width={1600}
          height={900}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-8 py-16 md:py-24 w-full">
        <div className="max-w-2xl">
          <div
            className={`transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}
          >
            <div className="inline-flex items-center gap-2 bg-[#F6C344] text-[#1A365D] text-xs font-bold uppercase tracking-[0.15em] px-4 py-2 rounded-full mb-6">
              <i className="ri-map-pin-line"></i>
              Serving Aventura &amp; South Florida
            </div>
          </div>

          <h1
            className={`font-serif text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6 transition-all duration-700 delay-100 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}
          >
            Expedited Passport Services in{" "}
            <span className="text-[#F6C344]">Aventura, FL</span>
          </h1>

          <p
            className={`text-white/80 text-base md:text-lg leading-relaxed mb-8 max-w-xl transition-all duration-700 delay-200 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}
          >
            Emergency passport processing for Aventura residents — as fast as 24 hours. 
            Whether you are flying from MIA, sailing from Port Everglades, or heading to 
            Latin America for business or family, we get you there on time. No agency lines. 
            No guessing. Start online today.
          </p>

          <div
            className={`flex flex-col sm:flex-row items-start gap-4 transition-all duration-700 delay-300 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}
          >
            <a
              href="https://fastpassportcenter.com/checkout/"
              className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-base px-8 py-4 rounded-md transition-all hover:scale-105 whitespace-nowrap"
            >
              Start My Passport <i className="ri-arrow-right-line"></i>
            </a>
            <a
              href="tel:8772530084"
              className="inline-flex items-center gap-2 bg-white/10 hover:bg-white/20 text-white font-semibold text-base px-6 py-4 rounded-md transition-all backdrop-blur-sm whitespace-nowrap"
            >
              <i className="ri-phone-line text-[#F6C344]"></i> 877-253-0084
            </a>
          </div>

          {/* Trust badges */}
          <div
            className={`flex flex-wrap items-center gap-x-6 gap-y-3 mt-10 transition-all duration-700 delay-400 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}
          >
            {[
              { icon: "ri-shield-check-line", text: "Registered State Dept. Courier" },
              { icon: "ri-award-line", text: "A+ BBB Rating" },
              { icon: "ri-time-line", text: "24-Hour Emergency Processing" },
            ].map((badge, i) => (
              <div key={i} className="flex items-center gap-2 text-white/60 text-xs">
                <i className={`${badge.icon} text-[#F6C344]`}></i>
                <span>{badge.text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}